<template>
  <div class="chat-container w-100 position-relative bg-white">
    <div id="hotel-request"></div>
    <div class="position-relative z-index-1028">
      <div class="row no-gutters justify-content-center">
        <div class="fixed-top d-block nav-bottom">
          <div class="custom-container-fluid px-0">
            <div class="row justify-content-center no-gutters">
              <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
                <div class="bg-white box-shadow-nav">
                  <div class="container px-4 w-100 py-1">
                    <div class="row no-gutters py-2 m-0 w-100">
                      <div class="col-1">
                        <div class="">
                          <router-link :to="'/'+getMerchant().code+'/concierge'">
                            <img src="../../../../assets/img/icon/back-arrow.png" class="mt-1" width="15">
                          </router-link>
                        </div>
                      </div>
                      <div class="col-9">
                        <div class="">
                          <p class="mb-0 body-1-2 nav-hotel ml-3 mt-1">{{$t('hotel.concierge.ask-for-help')}}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="height: 55px"></div>
    <div v-if="is_load" class="w-100 py-4 text-center">
      <loader />
    </div>
    <template v-else>
      <ErrorMessage v-if="error != ''" :message="error" />
      <template v-else>
        <div class="container px-4 mt-3 pb-4 box-shadow-primary">
          <p class="mb-0 body-1-1 text-26">{{general.tagline}}</p>
          <p class="mb-0 body-3-3">{{general.sub_tagline}}</p>
        </div>
        <div class="container p-4">
          <p class="mb-2 body-3-3 text-16 font-bold">{{$t('hotel.concierge.what-is-the-problem')}} <span class="text-danger">*</span></p>
          <v-select class="general-select-border body-2 rounded-6 text-14 mb-2" :options="item.list" label="name" :clearable="false" v-model="item.selected"></v-select>
          <template v-if="item.selected&&item.selected.is_show_form_label">
          	<p class="mb-2 mt-4 body-3-3 text-16 font-bold">{{$t('hotel.concierge.other-request')}} <span class="text-danger">*</span></p>
    		    <input
    		    	type="text" 
    		    	class="form-control px-2 body-2 rounded-6 text-14 mb-2" 
    	      	v-model="other_req" />
          </template>
          <p class="mb-2 mt-4 body-3-3 text-16 font-bold">{{$t('hotel.concierge.describe-more-clearly')}} <span class="text-danger">*</span></p>
          <textarea 
          	class="form-control px-2 body-2 rounded-6 text-14 mb-2" 
          	rows="3" 
          	:placeholder="$t('hotel.concierge.service-maintenance-example')"
          	v-model="note"> 
          </textarea>
          <p class="mb-2 mt-4 body-3-3 text-16 font-bold">{{$t('hotel.concierge.upload-photo-of-the-problem')}}</p>
          <div class="text-center mb-4">
            <label v-if="image.original == null" class="w-100 cursor-pointer" for="file_image">
              <div class="w-100 bg-light-page py-4 border-2-dashed rounded-6 cursor-pointer" style="box-shadow: 4px 3px 4px 0px #ccccccba;">
                <img src="../../../../assets/img/icon/ar-camera-light.png" width="40">
                <p class="mb-0 pt-1 body-1 text-14 font-bold text-center">{{$t('hotel.action.choose-photo')}}</p>
                <input type="file" ref="file" accept="image/png, image/jpeg, image/jpg" id="file_image" class="d-none" v-on:change="pushImage" />
              </div>
            </label>
            <div class="w-100 bg-light-page border rounded-6 position-relative" v-else style="box-shadow: 4px 3px 4px 0px #ccccccba;">
              <div class="rounded-3 bg-back cursor-pointer position-absolute m-2" @click="resetImage" style="z-index: 1049;right: 0">
                <img src="../../../../assets/img/icon/cancel.png" class="p-2" width="30">
              </div>
              <img :src="image.preview" class="rounded-6 w-100 object-fit" style="height: 190px">
            </div>
          </div>
          <ErrorMessage v-if="push_error != ''" :message="push_error" />
          <div class="position-relative" style="z-index: 1033">
            <div class="row no-gutters justify-content-center">
              <div class="fixed-bottom d-block nav-bottom" style="bottom:-10px">
                <div class="custom-container-fluid px-0">
                  <div class="row justify-content-center no-gutters">
                    <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
                      <div class="container px-4 pt-1 bg-white height-75px">
                        <div class="row justify-content-center slim-grid-row">
                          <div class="col-12">
                            <button type="button" :class="{'button-disabled': !form_valid}" class="button-primary w-100" @click="submitForm()">
                              <pulse-loader :loading="push_loader" color="#fff" v-if="push_loader"></pulse-loader>
                              <template v-else>
                                {{$t('hotel.action.send-request')}}
                              </template>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </template>

   	<template v-if="show_success_popup">
	    <transition name="fade">
	    	<div class="w-100">
	        <PopUpBackground></PopUpBackground>
	        <PopUpSuccess></PopUpSuccess>
	    	</div>
	    </transition>
   	</template>
    <popupWarningAddProduct v-if="show_popup" @close="show_popup = false"></popupWarningAddProduct>
    <warning-box 
      v-if="error_chat.show" 
      title="Action Message"
      :body="`Your order was successfully made but failed to register a chat account. You will be redirected to a order history page in ${error_chat.timer} seconds`" />
  </div>
</template>
<script>
  import {mapGetters} from 'vuex';
  import Flickity from 'vue-flickity';
  import PopUpSuccess from '@/components/hotel/concierge/general/popUpSuccessRequest';
  import PopUpBackground from '@/components/hotel/concierge/general/popUpBG';
  import {get,post} from '@/services/index.js';
  import {compressImage} from '@/utils/index.js';
  import WarningBox from '@/components/general/WarningBox'

  export default{
    components: {
      Flickity,
      PopUpSuccess,
      PopUpBackground,
      WarningBox
    },
    metaInfo(){
      return {
        title: 'Maintenance Service',
        titleTemplate: this.getMetaTitleTemplate()
      }
    },
    data() {
      return {
        note:'',
        other_req: '',
        show_success_popup: false,
        is_detail_photo: false,
        is_load: true,
        error: '',
        general: {},
        item:{
          list: [],
          selected: null
        },
        push_loader: false,
        push_error: '',
        image:{
          preview: null,
          original: null,
          key: 0
        },
        show_popup: false,
        error_chat: {
          show: false,
          timer: 0
        }
      }
    },
    computed:{
    	form_valid(){
    		return (this.item.selected==null || Object.keys(this.item.selected).length == 0 || this.note == '' || (this.item.selected.is_show_form_label && this.other_req == '')) ? false : true
    	},
      show_error_chat(){
        return this.error_chat.show
      }
    },
    watch:{
      show_error_chat(){
        if (this.error_chat.show) {
          let looping = setInterval(() => {
            if (this.error_chat.timer > 0) {
              this.error_chat.timer--
            }else if(this.error_chat.timer == 0){
              this.error_chat.show = false
              clearInterval(looping)
              this.resetConciergeOrder()
              this.$router.push('/'+this.getMerchant().code+'/concierge/order?reload=1')
            }
          },1000) 
        }
      }
    },
    mounted() {
      document.getElementById('hotel-request').scrollIntoView({
        behavior: 'smooth'
      });
      this.loadData()
    },
    methods: {
      ...mapGetters(['getMerchant','getConciergeAuth','getConciergeReservation','getMetaTitleTemplate']),
      updateScroll() {
        this.scrollPosition = window.scrollY
      },
      pushImage(e) {
        e.preventDefault();
        var files = this.$refs.file.files;
        if (!files.length)
          return;
        this.image.original = files[0]
        this.image.preview = URL.createObjectURL(this.image.original);
        this.image.key++
      },
      resetImage(){
        this.image = {
          preview: null,
          original: null,
          key: 0
        }
      },
      submitForm(){
        if(this.getConciergeReservation().status == 'CHECKIN'){
        	if(this.form_valid && !this.push_loader){
            this.push_loader = true
            this.push_error = ''
            let params = {
              merchant_id: this.getMerchant().id,
              pms_detail_id: this.getConciergeAuth().detail_id,
              folio_no: this.getConciergeAuth().folio,
              services_id: this.item.selected.id,
              description: this.note,
              label: this.other_req
            }

            post("CONCIERGE","maintenance/tx-inquiry",params,"concierge_pin").then(response=>{
              let res = response.data
              if(res.success){
                if(this.image.original != null){
                  this.uploadImage(res.data.id)
                }else{
                  this.show_success_popup = true
                  this.push_loader = false
                }
              }else{
                this.push_error = res.message
                this.push_loader = false
              }
            })
        	}
        }else{
          this.show_popup = true
        }
      },
      async uploadImage(tx_service_id){
        let img_data = await compressImage(this.image.original).then(compressResult=>{
          if(compressResult != false){
            return compressResult
          }else{
            return null
          }
        })
        if(img_data != null){
          let fd = new FormData()

          fd.append("image_file", img_data, img_data.name)
          fd.append("tx_service_id", tx_service_id)
          fd.append("merchant_id", this.getMerchant().id)
          fd.append("pms_detail_id", this.getConciergeAuth().detail_id)
          fd.append("folio_no",this.getConciergeAuth().folio)

          post("CONCIERGE","maintenance/tx-inquiry-image",fd,"concierge_pin").then(response=>{
            let res = response.data
            if(res.success){
              this.show_success_popup = true
            }else{
              this.push_error = res.message
              this.push_loader = false
            }
          })
        }else{
          this.push_error = this.$t('warning-message.error-upload')
          this.push_loader = false
        }
      },
      loadData(){
        this.is_load = true
        get("CONCIERGE","maintenance/general",{
          merchant_id: this.getMerchant().id
        }).then(response=>{
          let res = response.data
          if(res.success){
            this.general = res.data
            get("CONCIERGE","maintenance/problem-option",{
              merchant_id: this.getMerchant().id
            }).then(response_prod=>{
              let res_prod = response_prod.data
              if(res_prod.success){
                this.item.list = res_prod.data
                if(this.item.list.length>0){
                  this.item.selected = this.item.list[0]
                }
              }else{
                this.error = res_prod.message
              }
              this.is_load = false
            })
          }else{
            this.error = res.message
            this.is_load = false
          }
        })
      },
    }
  }
</script>


// WEBPACK FOOTER //
// src/pages/hotel/concierge/maintenanceservice/MaintenanceService.vue